// eslint-disable-next-line import/named
import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
export const StyledAccordion = styled.div.withConfig({ displayName: "auir-41e20d9-StyledAccordion", componentId: "auir-41e20d9-1mzuhim" }) `
  display: flex;
  flex-direction: column;
  justify-content: stretch;

  ${injectSpacing('margin')}
`;
export const StyledSectionHeader = styled.h2.withConfig({ displayName: "auir-41e20d9-StyledSectionHeader", componentId: "auir-41e20d9-483td" }) `
  all: revert;

  margin: 0;

  &:not(:first-child) {
    margin-top: -1px;
  }

  &:focus-within {
    z-index: 1;
  }
`;
export const StyledSectionHeaderLabel = styled.span.withConfig({ displayName: "auir-41e20d9-StyledSectionHeaderLabel", componentId: "auir-41e20d9-8rr77x" }) `
  display: grid;
  grid-column: section-label;

  color: var(${(props) => props.theme.colors.interaction.label.default});

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.label.hover});
  }

  transition: transform 200ms var(${(props) => props.theme.easing});
  margin-inline-end: var(${(props) => props.theme.responsive.spacing.m});

  ${(props) => injectTypography(props, 'copy1')}

  @media (max-width: 439px) {
    word-break: break-word;
    hyphens: auto;
  }
`;
export const StyledSectionHeaderHint = styled.span.withConfig({ displayName: "auir-41e20d9-StyledSectionHeaderHint", componentId: "auir-41e20d9-161j8d2" }) `
  grid-column: section-label;
`;
export const StyledSectionHeaderHintLabel = styled.span.withConfig({ displayName: "auir-41e20d9-StyledSectionHeaderHintLabel", componentId: "auir-41e20d9-1ixttv5" }) `
  color: var(${(props) => props.theme.colors.ui.tertiary});

  ${(props) => injectTypography(props, 'copy2')};
`;
export const StyledSectionHeaderButton = styled.button.withConfig({ displayName: "auir-41e20d9-StyledSectionHeaderButton", componentId: "auir-41e20d9-w5g7fj" }) `
  all: revert;

  display: block;
  width: 100%;
  margin: 0;
  padding: 0;

  text-align: start;

  background: transparent;
  border: solid var(${(props) => props.theme.colors.ui.divider});
  border-width: 1px 0;

  cursor: pointer;

  appearance: none;
`;
export const StyledSectionHeaderButtonContent = styled.span.withConfig({ displayName: "auir-41e20d9-StyledSectionHeaderButtonContent", componentId: "auir-41e20d9-uvkrl4" }) `
  display: grid;
  grid-template-columns:
    [section-icon] minmax(0, max-content)
    [section-label] auto
    [arrow-icon] max-content;
  padding: var(${(props) => props.theme.responsive.spacing.m})
    var(${(props) => props.theme.responsive.spacing.l});

  color: var(${(props) => props.theme.colors.interaction.label.default});

  &:hover {
    color: var(${(props) => props.theme.colors.interaction.label.hover});
  }

  &:focus {
    color: var(${(props) => props.theme.colors.interaction.label.focus});
  }
`;
export const StyledIcon = styled.svg.withConfig({ displayName: "auir-41e20d9-StyledIcon", componentId: "auir-41e20d9-4cls5a" }) `
  grid-column: arrow-icon;
  grid-row: 1 / span 3;
  align-self: center;

  width: 24px;
  height: 24px;

  transform: rotateZ(${(props) => (props.$open ? -180 : 0)}deg);

  transition: transform 200ms var(${(props) => props.theme.easing});

  pointer-events: none;

  [dir='rtl'] & {
    transform: rotateZ(${(props) => (props.$open ? 180 : 0)}deg);
  }
`;
const transitionDuration = 400;
export const StyledSectionPanel = styled.div.withConfig({ displayName: "auir-41e20d9-StyledSectionPanel", componentId: "auir-41e20d9-142ki3j" }) `
  --panel-height: ${(props) => (props.$defaultOpen ? 'auto' : '0px')};

  box-sizing: border-box;
  height: var(--panel-height);
  overflow: hidden;

  background-color: var(${(props) => props.theme.colors.ui.highlight.tertiary});
  visibility: ${(props) => (props.$open ? 'visible' : 'hidden')};

  transition: ${transitionDuration}ms var(${(props) => props.theme.easing});
  transition-property: height, visibility;
`;
export const StyledSectionPanelContent = styled.div.withConfig({ displayName: "auir-41e20d9-StyledSectionPanelContent", componentId: "auir-41e20d9-eqhzg3" }) `
  --inset: var(${(props) => props.theme.responsive.spacing.l});

  box-sizing: border-box;
  padding: var(--inset);

  transform: ${(props) => !props.$open && 'translateY(calc(var(--inset) / 2))'};
  opacity: ${(props) => (props.$open ? 1 : 0)};

  transition-delay: ${(props) => props.$open ? transitionDuration * 0.2 : 0}ms;
  transition-timing-function: var(${(props) => props.theme.easing});
  transition-duration: ${transitionDuration * 0.8}ms;
  transition-property: transform, opacity;
`;
export const StyledIconContainer = styled.span.withConfig({ displayName: "auir-41e20d9-StyledIconContainer", componentId: "auir-41e20d9-1qdllia" }) `
  display: inline-block;
  grid-column: section-icon;
  margin-inline-end: var(${(props) => props.theme.responsive.spacing.m});

  width: 24px;
  height: 24px;
`;
export const StyledSublineContainer = styled.span.withConfig({ displayName: "auir-41e20d9-StyledSublineContainer", componentId: "auir-41e20d9-8r49fo" }) `
  grid-column: section-label;
  color: var(${(props) => props.theme.colors.ui.tertiary});
  ${(props) => injectTypography(props, 'copy2')};
`;
//# sourceMappingURL=Accordion.styles.mjs.mjs.map